/* eslint-disable import/extensions */

// Services Img Imports
import IT from '../assets/images/Services/IT.gif';
import Dev from '../assets/images/Services/Dev.gif';
import Cloud from '../assets/images/Services/Cloud.gif';
import Data from '../assets/images/Services/Data.gif';
import ITOp from '../assets/images/Services/ITOP.gif';
import Digital from '../assets/images/Services/Digital.gif';

// Portfolio Img Imports
import Recruiting from '../assets/images/Portfolio/AI.png';
import Stream from '../assets/images/Portfolio/Cloud.png';
import Freelance from '../assets/images/Portfolio/Digital.png';

// Advantages
import Communicative from '../assets/images/Advantages/Communicative.gif';
import Collaborative from '../assets/images/Advantages/Collaborative.gif';
import Management from '../assets/images/Advantages/Management.gif';
import Favorite from '../assets/images/Advantages/Favourite.gif';

// Testimonials
import Sasha from '../assets/images/Testimonials/Sasha.jpg';
import Reiner from '../assets/images/Testimonials/Reiner.jpg';
import Kruger from '../assets/images/Testimonials/Kruger.jpg';

// TeamMembers
import CEO from '../assets/images/TeamMembers/CEO.jpg';
import HRD from '../assets/images/TeamMembers/HRD.jpg';
import Finance from '../assets/images/TeamMembers/Finance.jpg';
import ProjectManager from '../assets/images/TeamMembers/Project-manager.jpg';
import Frontend1 from '../assets/images/TeamMembers/Frontend1.jpg';
import Frontend2 from '../assets/images/TeamMembers/Frontend2.jpg';
import Backend1 from '../assets/images/TeamMembers/Backend1.jpg';
import Backend2 from '../assets/images/TeamMembers/Backend2.jpg';
import Mobile1 from '../assets/images/TeamMembers/Mobile1.jpg';
import Mobile2 from '../assets/images/TeamMembers/Mobile2.jpg';
import UIUX1 from '../assets/images/TeamMembers/UIUX1.jpg';
import UIUX2 from '../assets/images/TeamMembers/UIUX2.jpg';

export const Services = [
  {
    title: 'IT Consulting',
    imageUrl: IT,
    animation: 'up',
    description: 'Expert advice to help you navigate the complexities of IT.',
  },
  {
    title: 'Software Development',
    imageUrl: Dev,
    animation: 'up',
    description: 'Custom software solutions tailored to your business needs.',
  },
  {
    title: 'Cloud Services',
    imageUrl: Cloud,
    animation: 'up',
    description: 'Scalable cloud solutions for your growing business.',
  },
  {
    title: 'Digital',
    imageUrl: Digital,
    animation: 'up',
    description: 'Transforming your business through digital innovation.',
  },
  {
    title: 'Data Analytics',
    imageUrl: Data,
    animation: 'up',
    description: 'Insights and analytics to drive your business decisions.',
  },
  {
    title: 'IT Operations & Management',
    imageUrl: ITOp,
    animation: 'up',
    description: 'Efficient management of your IT operations.',
  },
];

export const Portfolios = [
  {
    id: 'asd1293uasdads1',
    title: 'The Future of AI in Business',
    imageUrl: Recruiting,
    type: 'Artificial Intelligence',
    responsibility: [
      '',
      '',
    ],
    credit: '',
    description: 'Explore how artificial intelligence is reshaping industries and driving innovation.',
  },
  {
    id: 'asd1293uhjkhkjh2',
    title: 'Cloud Migration Strategies',
    imageUrl: Stream,
    type: 'Cloud Computing',
    responsibility: [
      '',
      '',
    ],
    credit: '',
    description: 'Learn best practices for seamless cloud migration and optimization.',
  },
  {
    id: 'asd1293uvbvcbbd3',
    title: 'Digital Transformation Trends',
    imageUrl: Freelance,
    type: 'Digital Strategy',
    responsibility: [
      '',
      '',
    ],
    credit: '',
    description: 'Stay ahead of the curve with the latest digital transformation trends and strategies.',
  },
  {
    id: 'asd1293softwaresec5',
    title: 'Software Security Practices',
    imageUrl: Freelance,
    type: 'Cybersecurity',
    responsibility: [
      '',
      '',
    ],
    credit: '',
    description: 'Implement key software security practices to safeguard applications and data effectively.',
  },
];

export const Advantages = [
  [{
    title: 'Communicative',
    description: 'We communicate our project ideas and progress to make it clear',
    imageUrl: Communicative,
  },
  {
    title: 'Management',
    description: 'We manage our project properly to make our project done well.',
    imageUrl: Management,
  }],
  [{
    title: 'Collaborative​',
    description: 'Our team are very collaborative to make our project done well.',
    imageUrl: Collaborative,
  },
  {
    title: 'Favorite',
    description: "We manage our project properly to make our project done well.",
    imageUrl: Favorite,
  }],
];
export const Testimonials = [
  {
    id: 1,
    name: 'Sasha Rose',
    company: 'Owner, Surveyor Corps',
    testimoni: 'Thanks for Racxstudio, you guys are the best! Keep up the great work!',
    imageUrl: Sasha,
  },
  {
    id: 2,
    name: 'Kruger Khan',
    company: 'Director, Shultan Oil',
    testimoni: 'I just wanted to let you know that it’s been great working with Racxstudio.',
    imageUrl: Kruger,
  },
  {
    id: 3,
    name: 'Reiner John',
    company: 'CEO, Marley CO',
    testimoni: 'Racxstudio is so great. Thank you so much for a job well done.',
    imageUrl: Reiner,
  },
];

export const TeamMembers = [
  {
    name: 'To be Added',
    position: 'CEO',
    imageUrl: CEO,
  },
  {
    name: 'To be Added',
    position: 'HRD',
    imageUrl: HRD,
  },
  {
    name: 'To be Added',
    position: 'Finance',
    imageUrl: Finance,
  },
  {
    name: 'To be Added',
    position: 'Project Manager',
    imageUrl: ProjectManager,
  },
  {
    name: 'To be Added',
    position: 'Front-end Developer',
    imageUrl: Frontend1,
  },
  {
    name: 'To be Added',
    position: 'Front-end Developer',
    imageUrl: Frontend2,
  },
  {
    name: 'To be Added',
    position: 'Back-end Developer',
    imageUrl: Backend1,
  },
  {
    name: 'To be Added',
    position: 'Back-end Developer',
    imageUrl: Backend2,
  },
  {
    name: 'To be Added',
    position: 'Mobile Developer',
    imageUrl: Mobile1,
  },
  {
    name: 'To be Added',
    position: 'Mobile Developer',
    imageUrl: Mobile2,
  },
  {
    name: 'To be Added',
    position: 'UI/UX Designer',
    imageUrl: UIUX2,
  },
  {
    name: 'To be Added',
    position: 'UI/UX Designer',
    imageUrl: UIUX1,
  },
];
